import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "share-popup" }
const _hoisted_2 = { class: "popup-main black" }
const _hoisted_3 = { class: "popup-content" }
const _hoisted_4 = { class: "share-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "popup-footer" }
const _hoisted_7 = { class: "flex justify-center" }

import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import QrcodeVue from 'qrcode.vue'
import { useHelpTool } from '@/hooks';
import { shareSocialMedia } from "@/api";


export default {
  __name: 'SharePop',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { t } = useI18n();

const { copy, openBrowser } = useHelpTool()


const shareMethods = ref([]);
const shareUrl = ref('');
const shareUrls = ref({})

const showQrcode = ref(false);

onMounted(() => {
  shareMethods.value = [
    { code: 'whatsapp', icon: 'whatsapp', iconColor: '#00C451' },
    { code: 'facebook', icon: 'facebook', iconColor: '#007FFF' },
    { code: 'viber', icon: 'viber', iconColor: '#7D3DAF' },
    { code: 'telegram', icon: 'telegram', iconColor: '#1296DB' },
    { code: 'twitter', icon: 'x-twitter', iconColor: '#3B5998' },
    // { code: 'messenger', icon: 'messenger', iconColor: '#0084FF' },
    { code: 'sms', icon: 'sms', iconColor: '#009688' },
    { code: 'qrcode', icon: 'qrcode', iconColor: '#3E2AD1' },
    { code: 'more', icon: 'ellipsis-vertical', iconColor: '#007FFF' },
  ]
  if (!window.$bridge && !navigator.share) {
    shareMethods.value = shareMethods.value.filter(item => item.code !== 'more');
  }
  getShareLink();
})

const getShareLink = () => {
  shareSocialMedia().then(res => {
    const url = res.data;
    const shareText = t('share.title');
    const text = `${shareText} ${url}`;

    shareUrl.value = url;
    shareUrls.value = {
      whatsapp: `https://wa.me/?text=${text}`,
      telegram: `https://t.me/share/url?url=${url}&text=${encodeURIComponent(shareText)}`,
      viber: `viber://forward?text=${text}`, // Will open Viber app if installed
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${url}`,
      messenger: `https://www.messenger.com/share?link=${url}`,
      sms: `sms:?body=${text}`
    };
  }) 
}

const doShare = (method) => {
  if (method === 'more') {
    emit('onClose');
    doNormalShare();
  } else if (method === 'qrcode'){ // 二维码
    showQrcode.value = !showQrcode.value;
  } else {  // 平台分享
    emit('onClose');
    const target = shareUrls.value[method];
    if (target) {
      if (method === 'sms') {
        window.location.href = target; // SMS requires location.href
      } else {
        if (window.$bridge) {
          //在壳包H5内的效果
          openBrowser(target);
        } else {
          window.open(target, '_blank', 'noopener,width=600,height=400');
        } 
      }
    } 
  }
}

const doNormalShare = () => {
  const url = shareUrl.value;
  if (window.$bridge) {
    window.$bridge.callHandler('share', JSON.stringify({
      method: 'app',
      url,
      type: 'url'
    }))
  } else {
    // Try Web Share (best UX on mobile)
    navigator.share({
      title: t('share.title'),
      text: t('share.content'),
      url,
    }).catch(err => {
      if (err.name !== 'AbortError') {
        copy(url);
      }
    });
    return;
  }
}

return (_ctx, _cache) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      position: "bottom",
      "close-on-click-overlay": false,
      onClickOverlay: _cache[1] || (_cache[1] = $event => (emit('onClose')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareMethods.value, (method) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: method.code,
                  class: "share-item flex justify-center",
                  onClick: $event => (doShare(method.code))
                }, [
                  _createVNode(_component_SvgIcon, {
                    class: "method-icon",
                    name: method.icon,
                    style: _normalizeStyle({ 'background': method.iconColor || 'unset' })
                  }, null, 8, ["name", "style"])
                ], 8, _hoisted_5))
              }), 128))
            ]),
            (showQrcode.value && shareUrl.value)
              ? (_openBlock(), _createBlock(QrcodeVue, {
                  key: 0,
                  class: "qrcode-img",
                  value: shareUrl.value,
                  level: "M",
                  "render-as": "svg",
                  background: "#ffffff",
                  gradient: "true",
                  "gradient-type": "linear",
                  "gradient-start-color": "#1678ff",
                  "gradient-end-color": "#36a98f"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                class: "copy-btn",
                onClick: _cache[0] || (_cache[0] = $event => {_unref(copy)(shareUrl.value); emit('onClose');})
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('share.copy')), 1)
                ]),
                _: 1
              })), [
                [_directive_audio]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

}